/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface ArticleStatusTypesGet$Json$Params {
}

export function articleStatusTypesGet$Json(http: HttpClient, rootUrl: string, params?: ArticleStatusTypesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, articleStatusTypesGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

articleStatusTypesGet$Json.PATH = '/Article/StatusTypes';
